import { COLORS } from "@asayinc/component-library";

const ADDITIONAL_MAILING_OPERATION_STATUSES = {
  draft: {
    label: "Draft",
    color: COLORS.SATURATED_GREEN,
  },
  pending: {
    label: "Pending",
    color: COLORS.SATURATED_GREEN,
  },
  ready_for_review: {
    label: "Ready for review",
    color: COLORS.SATURATED_GREEN,
  },
  approved: {
    label: "Approved",
    color: COLORS.SATURATED_GREEN,
  },
  deleted_duplicate: {
    label: "Deleted - Duplicate",
    color: COLORS.SATURATED_RED,
  },
  deleted_cancelled: {
    label: "Deleted - Cancelled",
    color: COLORS.SATURATED_RED,
  },
  deleted_missed_deadline: {
    label: "Deleted - Missed Deadline",
    color: COLORS.SATURATED_RED,
  },
};

const PROXY_OPERATION_STATUSES = {
  draft: {
    label: "Draft",
    color: COLORS.SATURATED_GREEN,
  },
  new: {
    label: "New",
    color: COLORS.SATURATED_GREEN,
  },
  active: {
    label: "Active",
    color: COLORS.SATURATED_GREEN,
  },
  materials_requested: {
    label: "Materials requested",
    color: COLORS.SATURATED_GREEN,
  },
  materials_expected: {
    label: "Materials expected",
    color: COLORS.SATURATED_GREEN,
  },
  materials_confirmed: {
    label: "Materials confirmed",
    color: COLORS.SATURATED_GREEN,
  },
  ready_for_review: {
    label: "Ready for review",
    color: COLORS.SATURATED_GREEN,
  },
  approved: {
    label: "Approved",
    color: COLORS.SATURATED_GREEN,
  },
  deleted_legacy: {
    label: "Deleted - Legacy",
    color: COLORS.SATURATED_RED,
  },
  deleted_duplicate: {
    label: "Deleted - Duplicate",
    color: COLORS.SATURATED_RED,
  },
  deleted_missed_deadline: {
    label: "Deleted - Missed Deadline",
    color: COLORS.SATURATED_RED,
  },
  deleted_cancelled: {
    label: "Deleted - Cancelled",
    color: COLORS.SATURATED_RED,
  },
  closed: {
    label: "Closed",
    color: COLORS.SATURATED_RED,
  },
  closed_missing_responses: {
    label: "Closed - Missing Responses",
    color: COLORS.SATURATED_RED,
  },
  closed_cancelled: {
    label: "Closed - Cancelled",
    color: COLORS.SATURATED_RED,
  },
};

const VCA_STATUSES = {
  new: {
    label: "New",
    color: COLORS.SATURATED_GREEN,
  },
  in_progress: {
    label: "In progress",
    color: COLORS.SATURATED_GREEN,
  },
  approved: {
    label: "Approved",
    color: COLORS.SATURATED_GREEN,
  },
  closed: {
    label: "Closed",
    color: COLORS.SATURATED_RED,
  },
};

const NOBO_STATUSES = {
  new: {
    label: "New",
    color: COLORS.SATURATED_GREEN,
  },
  approved: {
    label: "Approved",
    color: COLORS.SATURATED_GREEN,
  },
  closed: {
    label: "Closed",
    color: COLORS.SATURATED_RED,
  },
};

const SRA_STATUSES = {
  new: {
    label: "New",
    color: COLORS.SATURATED_GREEN,
  },
  approved: {
    label: "Approved",
    color: COLORS.SATURATED_GREEN,
  },
  closed: {
    label: "Closed",
    color: COLORS.SATURATED_RED,
  },
};

const LAE_STATUSES = {
  new: {
    label: "New",
    color: COLORS.SATURATED_GREEN,
  },
  approved: {
    label: "Approved",
    color: COLORS.SATURATED_GREEN,
  },
  closed: {
    label: "Closed",
    color: COLORS.SATURATED_RED,
  },
};

const BANKRUPTCY_STATUSES = {
  awaiting_positions: {
    label: "Awaiting Positions",
    color: COLORS.SATURATED_GREEN,
  },
  positions_found: {
    label: "Positions Found",
    color: COLORS.SATURATED_GREEN,
  },
  ready_for_review: {
    label: "Ready for Review",
    color: COLORS.SATURATED_GREEN,
  },
  approved: {
    label: "Approved",
    color: COLORS.SATURATED_GREEN,
  },
  deleted_cancelled: {
    label: "Deleted - Cancelled",
    color: COLORS.SATURATED_RED,
  },
  closed_no_positions: {
    label: "Closed - No Positions",
    color: COLORS.SATURATED_RED,
  },
  closed_missing_responses: {
    label: "Closed - Missing Responses",
    color: COLORS.SATURATED_RED,
  },
};

const CLASS_ACTION_STATUSES = {
  automation_created: {
    label: "Automation Created",
    color: COLORS.SATURATED_GREEN,
  },
  awaiting_positions_and_trades: {
    label: "Awaiting Positions and Trades",
    color: COLORS.SATURATED_GREEN,
  },
  positions_or_trades_found: {
    label: "Positions Or Trades Found",
    color: COLORS.SATURATED_GREEN,
  },
  ready_for_review: {
    label: "Ready for Review",
    color: COLORS.SATURATED_GREEN,
  },
  approved: {
    label: "Approved",
    color: COLORS.SATURATED_GREEN,
  },
  deleted_cancelled: {
    label: "Deleted - Cancelled",
    color: COLORS.SATURATED_RED,
  },
  closed_no_positions_and_trades: {
    label: "Closed No Positions and Trades",
    color: COLORS.SATURATED_RED,
  },
  closed_missing_responses: {
    label: "Closed Missing Responses",
    color: COLORS.SATURATED_RED,
  },
};

export const ALL_STAGES = {
  ...ADDITIONAL_MAILING_OPERATION_STATUSES,
  ...PROXY_OPERATION_STATUSES,
  ...VCA_STATUSES,
  ...NOBO_STATUSES,
  ...SRA_STATUSES,
  ...LAE_STATUSES,
  ...BANKRUPTCY_STATUSES,
  ...CLASS_ACTION_STATUSES,
};
